import type { FilterType } from "@/features/members/utils/memberUtils";

export type FilterConfig = {
    type: FilterType;
    label: string;
    color: string;
};

/**
 * Filter configuration for member directory filters
 * Defines the display label and color for each filter type
 */
export const MEMBER_FILTER_CONFIG: FilterConfig[] = [
    { color: "bg-error", label: "Flagged", type: "flagged" },
    { color: "bg-tan", label: "Cancellations", type: "cancellations" },
    { color: "bg-tan/80", label: "Late Cancellations", type: "lateCancellations" },
    { color: "bg-grey", label: "No Shows", type: "noShows" },
    { color: "bg-secondary", label: "Inactive (3+ months)", type: "inactive" },
    { color: "bg-peach", label: "Waitlisted", type: "waitlisted" },
] as const;

export type BirthdayFilterState = "off" | "hasBirthday" | "noBirthday";

export const BIRTHDAY_FILTER_LABELS: Record<BirthdayFilterState, string> = {
    hasBirthday: "Has Birthday",
    noBirthday: "No Birthday",
    off: "Birthday",
};

export function nextBirthdayFilterState(current: BirthdayFilterState): BirthdayFilterState {
    if (current === "off") {
        return "hasBirthday";
    }
    if (current === "hasBirthday") {
        return "noBirthday";
    }
    return "off";
}
